
function isFunction(inFunction) {
    return inFunction && inFunction !== null && inFunction !== undefined && typeof inFunction === "function"; 
}

export {
    isFunction
};